import { useEffect, useState } from "react";
import { useForm } from 'react-hook-form'

import Modal from '../Modal';
import { createWorklog } from "../../api/tasks.api";
import { getWorklog, updateWorklog } from "../../api/worklog.api";
import { showSuccess, showError } from "../../services/toastServices";
import { CategoryData } from "../../pages/Category/CategoryWrapper";

export function WorklogModal({ task, worklogId, closeAction }) {
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
    const[worklog, setWorklog] = useState({})
    const {category, refreshProjectsCategory} = CategoryData();

    const getWorklogError = error => {
        setWorklog({})
        showError(`Error al recuperar la carga de horas. ${error.message}`)
    }

    useEffect(() => {
        async function loadWorklog() {
            if(worklogId){
                const res = await getWorklog(worklogId,getWorklogError)
                setWorklog(res.data)
                setValue('details', res.data.details)
                setValue('hours', res.data.hours)
            }
        }
   
        loadWorklog()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClose = () => {
        closeAction()
    };

    const actionBar = (
        <div className="flex">
            <button className=' bg-blue-400 rounded-md block w-10 hover:bg-blue-500' onClick={handleClose}>X</button>
        </div>
    )
    const renderHeader = () => {
        if(task){
            return(<h1 className='font-bold text-2xl'>{task.name} - Agregar horas</h1>)
        }else{
            return(<h1 className='font-bold text-2xl'>Editar horas</h1>)
        }
    }
    

    const handleSave = handleSubmit(async data => {
        if(task && task.id){
            const payload = {
                details: data.details,
                hours: data.hours,
            }
    
            await createWorklog(task.id, payload, createWorklogSuccess, createWorklogError)
        }
    })
    const handleUpdate = handleSubmit(async data => {
        
        if(worklogId){
            const payload = {
                details: data.details,
                hours: data.hours,
            } 
            await updateWorklog(worklogId, payload, updateWorklogSuccess, updateWorklogError)
        }
    })

    const createWorklogSuccess = (res => {
        showSuccess('Horas cargadas')
        refreshProjectsCategory(category)
        handleClose()
    })

    const createWorklogError = (error => {
        showError(`Error al cargar horas. ${error.message}. ${error.response.data}`)
    })

    const updateWorklogSuccess = (res => {
        showSuccess('Horas actualizada')
        refreshProjectsCategory(category)
        handleClose()
    })

    const updateWorklogError = (error => {
        showError(`Error al actualizar las horas. ${error.message}. ${error.response.data}`)
    })

    const renderButton = () => {
        if(!worklogId)
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleSave}>Crear</button>)
        else
            return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleUpdate}>Actualizar</button>)
    }

    const modal = <Modal onClose={handleClose} actionBar={actionBar} header={renderHeader} modalSize={'52'}>
        <div className='mt-3 grid grid-cols-3 '>
            <div className='col-span-3 ml-2'>
                <form action="" >
                    <input
                        type="text"
                        placeholder="Detalles"
                        {...register("details", { required: true })}
                        className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                    />
                    {errors.details && <span>Campo requerido</span>}

                    <input
                        type="number"
                        placeholder="Horas"
                        {...register("hours", { required: true })}
                        className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                    />
                    {errors.hours && <span>Campo requerido</span>}

                </form>

                {renderButton()}
            </div>
        </div>
    </Modal>

    return (
        <div>
            {modal}
        </div>
    )
}